<template>
  <div v-show="value" class="preview-wrapper">
    <div v-if="type == 'image'" @click.stop="handleClickItem">
      <el-image-viewer
        v-if="previewLists.length"
        ref="image-viewer"
        :url-list="previewLists"
        :z-index="999999"
        :on-close="handleClose"
      />
    </div>
    <div v-if="type == 'video'">
      <el-dialog v-model="visible" width="740px" title="视频预览" :before-close="handleClose">
        <video-player ref="playerRef" :src="url" width="100%" height="450px" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {
    ElImageViewer
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'image'
    }
  },
  data() {
    return {
      previewLists: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value: {
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            this.previewLists = [this.url]
            this.$refs['playerRef']?.play()
          })
        } else {
          this.$nextTick(() => {
            this.previewLists = []
            this.$refs['playerRef']?.pause()
          })
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
    },
    handleClickItem(event) {
      const target = event.target
      const viewerElement = document.querySelector('.el-image-viewer__wrapper') // 查找当前显示的查看器元素\
      if (viewerElement && viewerElement.contains(target) && target.classList.contains('el-image-viewer__mask')) {
        this.$refs['image-viewer'].hide() // 关闭查看器
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.preview-wrapper {
  ::v-deep .el-image-viewer__close {
    color: #fff;
  }
}

</style>
